export default __webpack_public_path__ + "static/white-logo-340x52-633fb01d580b7ac497cd35820e3dba1c.png";